import { ProfileState } from 'context/ProfileContext';
import { AuthUser } from 'context/AuthContext';
import { DashboardView } from 'utils/enums';

export type TipPlan = 'basic' | 'pro';

export interface Tip {
    id: string;
    titleKey: string;
    bodyKey: string;
    ctaKey: string;
    ctaView: DashboardView;
    plan: TipPlan;
    priority: number;
    condition: (state: ProfileState, user: AuthUser) => boolean;
}

export const BASIC_TIPS: Tip[] = [
    {
        id: 'add_avatar',
        titleKey: 'dashboard.main.tips.basic.addAvatar.title',
        bodyKey: 'dashboard.main.tips.basic.addAvatar.body',
        ctaKey: 'dashboard.main.tips.basic.addAvatar.cta',
        ctaView: DashboardView.PROFILE,
        plan: 'basic',
        priority: 1,
        condition: (_, user) => !user?.userImage?.fileName,
    },
    {
        id: 'add_bio',
        titleKey: 'dashboard.main.tips.basic.addBio.title',
        bodyKey: 'dashboard.main.tips.basic.addBio.body',
        ctaKey: 'dashboard.main.tips.basic.addBio.cta',
        ctaView: DashboardView.PROFILE,
        plan: 'basic',
        priority: 2,
        condition: (state) => !state.currentProfile.info?.description,
    },
    {
        id: 'first_link',
        titleKey: 'dashboard.main.tips.basic.firstLink.title',
        bodyKey: 'dashboard.main.tips.basic.firstLink.body',
        ctaKey: 'dashboard.main.tips.basic.firstLink.cta',
        ctaView: DashboardView.LINKS,
        plan: 'basic',
        priority: 3,
        condition: (state) => state.currentProfile.links.length === 0,
    },
    {
        id: 'more_links',
        titleKey: 'dashboard.main.tips.basic.moreLinks.title',
        bodyKey: 'dashboard.main.tips.basic.moreLinks.body',
        ctaKey: 'dashboard.main.tips.basic.moreLinks.cta',
        ctaView: DashboardView.LINKS,
        plan: 'basic',
        priority: 4,
        condition: (state) => state.currentProfile.links.length > 0 && state.currentProfile.links.length < 5,
    },
    {
        id: 'customize',
        titleKey: 'dashboard.main.tips.basic.customize.title',
        bodyKey: 'dashboard.main.tips.basic.customize.body',
        ctaKey: 'dashboard.main.tips.basic.customize.cta',
        ctaView: DashboardView.APPEARANCE,
        plan: 'basic',
        priority: 5,
        condition: () => true,
    },
    {
        id: 'publish',
        titleKey: 'dashboard.main.tips.basic.publish.title',
        bodyKey: 'dashboard.main.tips.basic.publish.body',
        ctaKey: 'dashboard.main.tips.basic.publish.cta',
        ctaView: DashboardView.DASHBOARD,
        plan: 'basic',
        priority: 6,
        condition: (state) => !state.isPublished,
    },
];

// Pro tips — structure ready, content pending pro plan launch
export const PRO_TIPS: Tip[] = [];

export const getTipsForPlan = (plan: TipPlan): Tip[] =>
    plan === 'pro' ? PRO_TIPS : BASIC_TIPS;

export const getRelevantTips = (
    tips: Tip[],
    state: ProfileState,
    user: AuthUser
): Tip[] =>
    tips
        .filter(tip => tip.condition(state, user))
        .sort((a, b) => a.priority - b.priority);
